import React from "react";
import styles from "./Membershipandaffiliation.module.css";
import Image from "next/image";

interface Data {
  title: string;
  list: listItems[];
  images: cardImages[];
}

interface listItems {
  item: string;
  id: number;
}

interface cardImages {
  alternativeText: string;
  id: number;
  url: string;
}

interface AccreditationsMembershipandaffiliationProps {
  data: Data;
}

export const AccreditationsMembershipandaffiliation: React.FC<
  AccreditationsMembershipandaffiliationProps
> = ({ data }) => {
  return (
    <div className={styles.affiliationRow}>
      <div className="container">
        <div className={styles.innerContainer}>
          <div className={styles.leftContainer}>
            <h3>{data?.title}</h3>
            <ul className={styles.affiliationList}>
              {data?.list.map((item) => (
                <li key={item?.id}>{item?.item}</li>
              ))}
            </ul>
          </div>
          <div className={styles.imageContainer}>
            {data?.images.map((item) => (
              <Image
                src={item?.url}
                alt={item?.alternativeText}
                title={item?.alternativeText}
                width={131}
                height={56}
                className={styles.logo}
                key={item?.id}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
